import React from 'react'
import PropTypes from 'prop-types'
import { gcsURL } from '../../../../utils/gcsUrl'
import { SHERWIN_WILLIAMS_LOGO } from '../../../constants/AppImages'

/**
 * @typedef LogoProps
 * @prop {'small' | 'large'} size
 */

/**
 * @param {LogoProps} props
 */
export default function Logo({ size }) {
  return (
    <img
      alt="LOGO"
      src={gcsURL('app/cv/shw/app_images', SHERWIN_WILLIAMS_LOGO)}
      height={size === 'small' ? '45px' : '60px'}
    />
  )
}

Logo.propTypes = {
  size: PropTypes.string,
}

Logo.defaultProps = {
  size: 'small',
}
